var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.13818C9.38 2.13818 7.25 4.26818 7.25 6.88818C7.25 9.45818 9.26 11.5382 11.88 11.6282C11.96 11.6182 12.04 11.6182 12.1 11.6282C12.12 11.6282 12.13 11.6282 12.15 11.6282C12.16 11.6282 12.16 11.6282 12.17 11.6282C14.73 11.5382 16.74 9.45818 16.75 6.88818C16.75 4.26818 14.62 2.13818 12 2.13818Z",
    fill: "#464650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.08 14.2882C14.29 12.4282 9.73996 12.4282 6.92996 14.2882C5.65996 15.1382 4.95996 16.2882 4.95996 17.5182C4.95996 18.7482 5.65996 19.8882 6.91996 20.7282C8.31996 21.6682 10.16 22.1382 12 22.1382C13.84 22.1382 15.68 21.6682 17.08 20.7282C18.34 19.8782 19.04 18.7382 19.04 17.4982C19.03 16.2682 18.34 15.1282 17.08 14.2882Z",
    fill: "#464650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.80a0532a298b25d38f3ce7c502392ba7.svg";
export { ForwardRef as ReactComponent };